import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { HttpService } from 'src/app/services/http.service';
import { Answer, Question, TestImage, TestItem } from '../../interfaces';
import { CountdownService } from '../services/countdown.service';
import {
  FormBuilder,
  FormControl,
  FormGroup,
  Validators,
} from '@angular/forms';
import { UiServices } from 'src/app/services/ui-services';
import { NavController } from '@ionic/angular';
import { ParamServicesService } from 'src/app/services/param-services.service';
import { ModuleTestService } from '../services/module-test.service';

@Component({
  selector: 'app-test-show',
  templateUrl: './test-show.page.html',
  styleUrls: ['./test-show.page.scss'],
})
export class TestShowPage implements OnInit {
  public test: TestItem;
  public loading = true;
  public message = '';
  public subtitle = '';
  public formGroup: FormGroup;
  public testImage: TestImage;
  public approvedTest = false;
  public inscriptionId = '';

  constructor(
    public countdown: CountdownService,
    private httpSv: HttpService,
    private route: ActivatedRoute,
    private fb: FormBuilder,
    private uiSv: UiServices,
    private navCtrl: NavController,
    private paramSv: ParamServicesService,
    private moduleTestSv: ModuleTestService
  ) {}

  async ngOnInit() {
    this.inscriptionId = this.route.snapshot.paramMap.get('incription_id');
    const id = this.route.snapshot.paramMap.get('test_id');

    const res = await this.httpSv.itemIndex(
      'learningTests',
      '',
      { id, inscriptionId: this.inscriptionId },
      'show'
    );

    this.test = res.data;
    if (!res.status) {
      if ((res.data as TestItem).reazon) {
        if (!Object.values(this.paramSv.headerParams).length) {
          const obs = this.paramSv.emitImagesObs.subscribe((data) => {
            if (data === 'finish') {
              this.moduleTestSv.showReasonModal(res.data, this.inscriptionId);
              obs.unsubscribe();
            }
          });
        } else {
          this.moduleTestSv.showReasonModal(res.data, this.inscriptionId);
        }
        return;
      }
    }

    if (!this.test.progress) {
      await this.sendProgress();
      await this.ngOnInit();
      return;
    }

    this.message = res.message;
    if (res.message) {
      if (!this.paramSv.testImages.length) {
        const obs = this.paramSv.emitImagesObs.subscribe((data) => {
          if (data === 'finish') {
            this.verifyTest();
            obs.unsubscribe();
          }
        });
      } else {
        this.verifyTest();
      }
      return;
    }

    const targetDate = new Date(this.test.dateEnd);
    const parsedTargetDate = new Date(
      targetDate.toLocaleString('en-US', {
        timeZone: Intl.DateTimeFormat().resolvedOptions().timeZone,
      })
    );
    this.countdown.targetDate = parsedTargetDate;
    this.countdown.startTime();
    const countdown = this.countdown.finishedTest$.subscribe(async () => {
      if (res.status) {
        countdown.unsubscribe();
        this.handleSubmit();
        await this.uiSv.presentAlert(
          'El tiempo del examen ha finalizado',
          false
        );
        await this.navCtrl.navigateRoot('/virtual-class');
      }
    });
    this.loading = false;

    const obj: any = {};
    this.test.question.forEach((item) => {
      if (item.type === 'selectionMultiple') {
        obj[item.id] = new FormControl([], [Validators.required]);
      } else {
        obj[item.id] = new FormControl(null, [Validators.required]);
      }
    });

    this.formGroup = this.fb.group(obj);
  }

  async verifyTest() {
    if (this.test?.progressTest.pendingForApprove) {
      this.testImage = this.paramSv.testImages.find(
        (x) => x.name === 'pendingForApprove'
      );
      this.approvedTest = true;
    } else if (this.test?.progressTest.hitPercentage < 50) {
      this.testImage = this.paramSv.testImages.find(
        (x) => x.name === 'reprobate'
      );
    } else if (this.test?.progressTest.hitPercentage >= 50) {
      this.testImage = this.paramSv.testImages.find(
        (x) => x.name === 'approved'
      );
      this.approvedTest = true;
    }

    this.subtitle = `${this.testImage.subtitle} ${
      this.test.progressTest.qualification || 0
    }/${this.test.progressTest.qualificationMax || 0}`;

    this.loading = false;
  }

  async sendProgress() {
    const id = this.route.snapshot.paramMap.get('test_id');
    await this.httpSv.itemAction(
      {
        learningTestId: id,
      },
      'learning',
      'progress'
    );
  }

  async continue() {
    if (this.test.repeat && !this.approvedTest) {
      await this.sendProgress();
      await this.ngOnInit();
    } else {
      this.goBack();
    }
  }

  async goBack() {
    await this.navCtrl.navigateRoot(
      `/virtual-class/module/${this.inscriptionId}/${this.test.learningModuleId}`
    );
  }

  setAnswer(ev: Event, id: Answer['id'], questionId: Question['id']) {
    const event = ev.target as HTMLIonCheckboxElement;
    let values: any[] = this.formGroup.get(questionId.toString()).value;
    if (event.checked) {
      values.push(id);
    } else {
      values = values.filter((item) => item !== id);
    }
    this.formGroup.get(questionId.toString()).setValue(values);
  }

  async handleSubmit() {
    try {
      const results = [];
      await this.uiSv.showLoading();
      for (const key in this.formGroup.value) {
        results.push({
          id: +key,
          answer: this.formGroup.value[key],
          type: this.test.question.find((item) => item.id === +key).type,
        });
      }
      await this.httpSv.itemAction(
        { answer: results, testId: this.test.id },
        'learningTests/answers',
        'store'
      );
    } catch (error) {
      console.error(error);
    } finally {
      await this.uiSv.loading.dismiss();
      await this.ngOnInit();
    }
  }
}
